import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Option } from '../../../../../../../../../ui-components/core-dropdown/core-dropdown.component';
import { ParameterService } from '../../../../../../../../../shared/services/parameter/parameter.service';
import { AddressAutocompleteComponent } from '../../../../../../../../../ui-components/address-autocomplete/address-autocomplete.component';
import { InstituationService } from '../../../../../../../../instituation/services/institiuation.service';

@Component({
  selector: 'app-save-intituation-popup',
  standalone: false,

  templateUrl: './save-intituation-popup.component.html',
  styleUrl: './save-intituation-popup.component.scss'
})
export class SaveIntituationPopupComponent implements OnInit {

  @ViewChild('addressComponent') addressComponent: AddressAutocompleteComponent;
  @Output() saved = new EventEmitter<any>();
  @Output() closed = new EventEmitter<void>();

  form!: FormGroup;
  instituationsTypes: Option[] = [];
  includeData:any;
  instPopupVisible = false;
  constructor(
    private readonly fb: FormBuilder,
    private readonly parameterService: ParameterService,
    private readonly insService: InstituationService,
  ) {
    this.form = this.fb.group({
      instituationType: [null, Validators.required],
      address: [null, Validators.required],
    });
  }
  ngOnInit() {
    this.form = this.fb.group({
      instituationType: [null, Validators.required],
      address: [null, Validators.required],
    });
    this.parameterService
      .getParameterValues('data-group', 'instituationTypes')
      .subscribe((response) => {
        this.instituationsTypes = response.datas.values.map((data: any) => {
          return { label: data.valueObject.name.value, value: data.id };
        });
      });

    this.form.get('instituationType')?.valueChanges.subscribe((val) => {
      if (val) {
        this.openAddressModal();
      }
    });
  }

  openDialog(formValues?: any) {
    this.includeData = formValues
    this.instPopupVisible = true;
  }

  closeDialog() {
    this.instPopupVisible = false;
    this.closed.emit();
  }
  save() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const formData = this.form.getRawValue();

    const payload = {
      title: this.includeData.institutionName ?? '',     
      signboard: this.includeData.institutionName ?? '',
      instituationType: formData.instituationType,
      taxOffice: this.includeData.taxOffice ?? '',
      taxNumber: this.includeData.taxNo ?? '',
      termDay:"",
      contacts: [
        {
          description: "",
          email: '',
          id: null,
          prefixValue: "+90",
          phone: this.includeData.phone ?? '',
          priority: true,
          relativePhone: ''
        }
      ],
      address: {
        ...this.form.value?.address,
        latitude: Number(this.form.value?.address?.latitude),
        longitude: Number(this.form.value?.address?.longitude),
      },
      isActive: true,
      isMotherChildInstituation: true,
      erpCode: "",
      instituationShortCode: "",
      labmedInstituationCode: "",
      labmedUserPassword: "",
      labmedUsername: "",
      mainInstituationId: null,
      note: "",
      provisionable: false
    };

    this.insService.create(payload).subscribe({
      next: (res) => {
        if (res && res.id) {
          this.saved.emit({ ...formData, institutionId: res.id });
          this.closeDialog();
        }
      },
      error: (err) => {
        console.error('Kurum oluşturulamadı', err);
      }
    });
  }


  openAddressModal() {
    this.addressComponent.openDialog(this.form.value.address);
  }

  handleSetAddress(address: any) {
    this.form.patchValue({
      address: {
        ...address,
        latitude: Number(address?.latitude),
        longitude: Number(address?.longitude),
      },
    });
  }
  //CreateInstituationComponent
}
